import React from 'react';

export default function LoadingSpinner({ text = 'Cargando...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-mc-border rounded-full"></div>
        <div className="absolute inset-0 border-4 border-mc-accent rounded-full border-t-transparent animate-spin"></div>
      </div>
      <p className="mt-4 text-mc-muted text-sm">{text}</p>
    </div>
  );
}
